import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Input from "@mui/joy/Input";
import FormLabel from "@mui/joy/FormLabel";
import FormHelperText from "@mui/joy/FormHelperText";
import IconButton from "@mui/joy/IconButton";
import { Eye as EyeIcon } from "@phosphor-icons/react/dist/ssr/Eye";
import { EyeSlash as EyeSlashIcon } from "@phosphor-icons/react/dist/ssr/EyeSlash";
import {useDispatch} from 'react-redux'
import { login_user } from "../reduxData/auth/authAction";
import { useNavigate } from 'react-router-dom';
import logo from '../images/logo.png';


const NEWS_ITEMS = [
  { title: "Seller onboarding", text: "Review documents and activate or reject seller applications from user details." },
  { title: "Knowledge Base", text: "Create and manage help articles for buyers and sellers." },
  { title: "Orders & Payments", text: "Track orders, payouts and finance documents in one place." },
  { title: "Dispute management", text: "Resolve buyer and seller disputes faster with a clear history." },
  { title: "Staff permissions", text: "Give staff role-based access to only the sections they need." },
];

const Login = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  
  // handle value change 
  const handleChange = (e, name) => {
    const { value } = e.target;
    const updatedFormData = {
      ...formData,
      [name]: value,
    };
    setFormData(updatedFormData);

    const validationErrors = validateField(name, value);
    setErrors({
      ...errors,
      [name]: validationErrors[name],
    });
  };

  const validateField = (name, value) => {
    let fieldErrors = {};
    switch (name) {
      case "email":
        if (!value.trim()) {
          fieldErrors[name] = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(value)) {
          fieldErrors[name] = "Email is invalid";
        } else {
          fieldErrors[name] = "";
        }
        break;
      case "password":
        if (!value.trim()) {
          fieldErrors[name] = "Password is required";
        }
        else {
          fieldErrors[name] = "";
        }
        break;
      default:
        break;
    }
    return fieldErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    for (let key in errors) {
      if (errors.hasOwnProperty(key)) {
        if (
          errors[key] !== null &&
          errors[key] !== undefined &&
          errors[key] !== ""
        ) {
          console.log("You have an error ");
          return;
        }
      }
    }

    const validationErrors = validateForm(formData);
    if (Object.keys(validationErrors).length === 0) {
      const data = { ...formData, role: "admin" };
      await login_user(data,dispatch,navigate);
    } else {
      setErrors(validationErrors);
    }
  };

  // check validations 
  const validateForm = (data) => {
    let errors = {};
    if (!data.email.trim()) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(data.email)) {
      errors.email = "Email is invalid";
    }
    if (!data.password.trim()) {
      errors.password = "Password is required";
    } else if (data.password.length < 6) {
      errors.password = "Password must be at least 6 characters";
    }
    return errors;
  };

  return (
    <div className="lg-page">
      <div className="lg-left">
        <span className="lg-badge">Bid4Style • Admin Panel</span>
        <h1 className="lg-title">
          Everything your marketplace needs, <span>in one dashboard.</span>
        </h1>
        <p className="lg-desc">
          A simple, secure workspace for admins to manage sellers, products,
          orders, payments and disputes.
        </p>

        <div className="lg-news">
          <h3 className="lg-news-title">What's New</h3>
          <div className="lg-news-viewport">
            <div className="lg-news-track">
              {[...NEWS_ITEMS, ...NEWS_ITEMS].map((item, i) => (
                <div className="lg-news-item" key={i}>
                  <h4>{item.title}</h4>
                  <p>{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <p className="lg-copy">© 2026 Bid4Style</p>
      </div>

      <div className="lg-right">
        <div className="lg-card">
          <img src={logo} height={70} className="mx-auto mb-2 d-block" alt="Bid4Style" />
          <h2 className="lg-welcome">Welcome back</h2>
          <p className="lg-sub">Sign in with your admin account to continue.</p>
          <Form onSubmit={handleSubmit} noValidate>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <FormLabel>Email address</FormLabel>
              <Input
                type="email"
                placeholder="Enter email address"
                value={formData.email}
                onChange={(e) => handleChange(e, 'email')}
              />
              {errors.email && (
                <FormHelperText style={{ color: 'red' }}>
                  {errors.email}
                </FormHelperText>
              )}
            </Form.Group>

            <Form.Group className="mb-4" controlId="formBasicPassword">
              <FormLabel>Password</FormLabel>
              <Input
                placeholder="Enter password"
                endDecorator={
                  <IconButton onClick={() => setShowPassword(!showPassword)}>
                    <i
                      className={showPassword ? "fas fa-eye" : "fas fa-eye-slash"}
                      style={{ color: 'grey' }}
                    />
                  </IconButton>
                }
                name="password"
                type={showPassword ? 'text' : 'password'}
                onChange={(e) => handleChange(e, 'password')}
              />
              {errors.password && (
                <FormHelperText style={{ color: 'red' }}>
                  {errors.password}
                </FormHelperText>
              )}
            </Form.Group>
            <Button variant="unset" className="btn common-button w-100" type="submit">
              Sign in <i className="fa-solid fa-arrow-right-long"></i>
            </Button>
          </Form>
          <div className="lg-secure">
            <i className="fa-solid fa-shield-halved"></i> Your data is protected and secure
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
